export const UPDATE = "messages/UPDATE";
export const UPDATE_ONE = "messages/UPDATE_ONE";
export const APPEND = "messages/APPEND";
export const PREPPEND = "messages/PREPPEND";
export const EMPTY = "messages/EMPTY";
export const LOADING = "messages/LOADING";
export const SET_CURRENT_CONVERSATION = "messages/SET_CURRENT_CONVERSATION";